import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { ContactMasterData } from "types/models/contactMaster/ContactMasterApp";
import { TransactionMasterData } from "types/models/transactionMaster/TransactionMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof TransactionMasterData;
  onSort: (property: keyof TransactionMasterData) => void;
}

const commonCellStyle = {
  fontSize: 14,
  minWidth: 120,       
  maxWidth: 180,        
  overflow: "hidden",
  whiteSpace: "normal", 
  wordBreak: "break-word", 
};
const headCells: { id: keyof TransactionMasterData; label: string }[] = [
  { id: "id", label: "Id" },
  { id: "Lead_EkycId", label: "Type" },
  { id: "CafId", label: "COF Id" },
  { id: "FirstName", label: "Customer Name" },
  { id: "ContactNumber", label: "RMN" },
  { id: "order_id", label: "Order Id" },
  { id: "PaymentMode", label: "Payment Mode" },
  { id: "TransactionId", label: "Txn Id" },
  { id: "updated_at", label: "Txn Date" },
   { id: "payableAmount", label: "Amount" },
   { id: "status", label: "Status" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof TransactionMasterData) => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          sx={commonCellStyle}
          sortDirection={orderBy === headCell.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
